export default {
  'menu.crm.nav.performance': 'Performance',
  'menu.crm.performance.overview': 'Overview',
  'menu.crm.performance.targets': 'Targets',
  'menu.crm.performance.entries': 'Ledger',
  'menu.crm.performance.splits': 'Allocations',
  'menu.crm.performance.team': 'Team attainment',
  'menu.crm.performance.reconciliation': 'Reconciliation',

  'menu.zy-crm.analytics.business': 'Business Analysis',
  'menu.zy-crm.analytics.customer': 'Customer Analysis',
  'menu.zy-crm.analytics.sales': 'Sales Analysis',
  'menu.zy-crm.analytics.performance': 'Performance Analysis',
  'menu.zy-crm.analytics.product': 'Product Analysis',
  'menu.crm.scope.my': 'Assigned to me',
  'menu.crm.scope.team': 'Assigned to my team',
  'menu.crm.scope.collab': 'Collaborating',
  'menu.crm.scope.followed': 'Following',
  'menu.crm.scope.all': 'All',
  'menu.crm.page.overview': 'Overview',
  'menu.crm.page.approval': 'Approvals',
  'menu.crm.page.calendar': 'Calendar',
  'menu.crm.page.business-trip': 'Business Trips',
  'menu.crm.page.task': 'Tasks',
  'menu.crm.page.follow-up': 'Follow-ups',
  'menu.crm.page.attachment': 'Attachments',
  'menu.crm.page.lead-source': 'Source analysis',

  'menu.crm.help': 'Help',
  'menu.crm.nav.workbench': 'Workbench',
  'menu.crm.nav.marketing': 'Marketing',
  'menu.crm.nav.lead': 'Leads',
  'menu.crm.nav.customer': 'Customers',
  'menu.crm.nav.contact': 'Contacts',
  'menu.crm.nav.opportunity': 'Opportunities',
  'menu.crm.nav.quote': 'Quotes',
  'menu.crm.nav.product': 'Products',
  'menu.crm.nav.contract': 'Contracts',
  'menu.crm.nav.receipt': 'Receipts',
  'menu.crm.nav.analysis': 'Analysis',
  'menu.zy-crm.products.catalog': 'Product catalog',
  'menu.zy-crm.workbench.overview': 'Overview',

  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.zy-crm': 'Organization Admin',
  'menu.zy-crm.workbench': 'Workspace',
  'menu.zy-crm.workbench.dashboard': 'Dashboard',
  'menu.zy-crm.approvals': 'Approval Center',
  'menu.zy-crm.leadManagement': 'Lead',
  'menu.zy-crm.leadManagement.lead.my': 'Mine',
  'menu.zy-crm.leadManagement.lead.team': 'Subordinates',
  'menu.zy-crm.leadManagement.lead.collab': 'Collaboration',
  'menu.zy-crm.leadManagement.lead.pool': 'Lead Pool',
  'menu.zy-crm.leadManagement.lead.all': 'All',
  'menu.zy-crm.customerManagement': 'Customer',
  'menu.zy-crm.customerManagement.customer.my': 'Mine',
  'menu.zy-crm.customerManagement.customer.team': 'Subordinates',
  'menu.zy-crm.customerManagement.customer.collab': 'Collaborating',
  'menu.zy-crm.customerManagement.customer.pool': 'Customer Pool',
  'menu.zy-crm.customerManagement.customer.all': 'All',
  'menu.zy-crm.customerManagement.contact': 'Contact',
  'menu.zy-crm.customerManagement.contact.my': 'Mine',
  'menu.zy-crm.customerManagement.contact.team': 'Subordinates',
  'menu.zy-crm.customerManagement.contact.collab': 'Collaborating',
  'menu.zy-crm.customerManagement.contact.all': 'All',
  'menu.zy-crm.customerManagement.contact.detail': 'Contact Detail',
  'menu.zy-crm.salesManagement': 'Opportunity',
  'menu.zy-crm.salesManagement.opportunity.my': 'Mine',
  'menu.zy-crm.salesManagement.opportunity.followed': 'Followed',
  'menu.zy-crm.salesManagement.opportunity.team': 'Subordinates',
  'menu.zy-crm.salesManagement.opportunity.collab': 'Collaborating',
  'menu.zy-crm.salesManagement.opportunity.all': 'All',
  'menu.zy-crm.salesManagement.opportunity.pool': 'Opportunity Pool',
  'menu.zy-crm.salesManagement.quote': 'Quotation',
  'menu.zy-crm.salesManagement.quote.my': 'Mine',
  'menu.zy-crm.salesManagement.quote.team': 'Subordinates',
  'menu.zy-crm.salesManagement.quote.collab': 'Collaborating',
  'menu.zy-crm.salesManagement.quote.all': 'All',
  'menu.zy-crm.salesManagement.quote.detail': 'Quote Detail',
  'menu.zy-crm.salesManagement.product': 'Product',
  'menu.zy-crm.salesManagement.product.detail': 'Product Detail',
  'menu.zy-crm.contractAndReceipt': 'Contracts & Receipts',
  'menu.zy-crm.contractAndReceipt.contract': 'Contract',
  'menu.zy-crm.contractAndReceipt.contract.detail': 'Contract Detail',
  'menu.zy-crm.contractAndReceipt.receipt': 'Receipt',
  'menu.zy-crm.contractAndReceipt.receipt.detail': 'Receipt Detail',
  'menu.zy-crm.contractAndReceipt.receipt-schedule': 'Receipt Schedule',
  'menu.zy-crm.contractAndReceipt.receipt-schedule.detail':
    'Receipt Schedule Detail',
  'menu.zy-crm.contractAndReceipt.invoice': 'Invoice',
  'menu.zy-crm.contractAndReceipt.invoice.detail': 'Invoice Detail',
  'menu.zy-crm.contractAndReceipt.invoiceProfile': 'Invoice Profile',
  'menu.zy-crm.collaboration': 'Collaboration',
  'menu.zy-crm.collaboration.calendar': 'Calendar',
  'menu.zy-crm.collaboration.followUps': 'Follow Ups',
  'menu.zy-crm.collaboration.tasks': 'Task Center',
  'menu.zy-crm.collaboration.attachments': 'Attachment Center',
  'menu.zy-crm.analytics': 'Analytics',
  'menu.zy-crm.analytics.leadSourceAnalysis': 'Lead Source Analysis',
  'menu.zy-crm.analytics.businessMap': 'Business Map',
  'menu.zy-crm.analytics.governance': 'Data Governance',
  'menu.zy-crm.settings.marketing': 'Marketing Settings',
  'menu.zy-crm.systemConfig': 'System Settings',
  'menu.zy-crm.systemConfig.general': 'General Settings',
  'menu.zy-crm.systemConfig.lead': 'Lead Settings',
  'menu.zy-crm.systemConfig.customer': 'Customer Settings',
  'menu.zy-crm.systemConfig.opportunity': 'Opportunity Settings',
  'menu.zy-crm.systemConfig.product': 'Product Settings',
  'menu.zy-crm.systemConfig.marketing': 'Marketing Settings',
  'menu.zy-crm.systemConfig.contract': 'Contract Settings',
  'menu.zy-crm.systemConfig.permissions': 'Permission Configuration',
  'menu.zy-crm.systemConfig.taxonomies': 'Tags',
  'menu.zy-crm.systemConfig.automationRules': 'Automation Rules',
  'menu.zy-crm.systemConfig.invoiceProfile': 'Invoice Profiles',
  'menu.zy-crm.systemConfig.tavily': 'Tavily Settings',
  'menu.zy-crm.systemConfig.modelSettings': 'Model Settings',
  'menu.zy-crm.systemConfig.customerPoolConfigs': 'Customer Pool Configs',
  'menu.zy-crm.systemConfig.leadPoolConfigs': 'Lead Pool Configs',
  'menu.zy-crm.systemConfig.leadAssignRules': 'Lead Assignment Rules',
  'menu.zy-crm.systemConfig.customerLimitConfigs': 'Private Pool Limits',
  'menu.zy-crm.systemConfig.dictionaryManagement': 'Dictionary Management',
  'menu.zy-crm.systemConfig.productCategories': 'Product Categories',
  'menu.zy-crm.systemConfig.opportunityPipelines': 'Opportunity Pipelines',
  'menu.zy-crm.systemConfig.opportunityStages': 'Opportunity Stages',
  'menu.zy-crm.systemConfig.areas': 'Area Configs',
  'menu.zy-crm.systemConfig.sourceChannels': 'Source Channel Configs',
  'menu.zy-crm.systemConfig.marketingCampaignTypes': 'Campaign Types',
  'menu.zy-crm.systemConfig.marketingTouchpointTypes': 'Touchpoint Types',
  'menu.zy-crm.systemConfig.industries': 'Industry Configs',
  'menu.zy-crm.systemConfig.contractConfigs': 'Contract Configs',
  'menu.zy-crm.systemConfig.contractCodeRules': 'Contract Code Rules',
  'menu.zy-crm.systemConfig.productCodeRules': 'Product Code Rules',
  'menu.zy-crm.dashboard': 'Dashboard',
  'menu.zy-crm.calendar': 'Calendar',
  'menu.zy-crm.lead': 'Lead',
  'menu.zy-crm.lead.my': 'My Leads',
  'menu.zy-crm.lead.pool': 'Lead Pool',
  'menu.zy-crm.lead.all': 'All Leads',
  'menu.zy-crm.customer': 'Customer',
  'menu.zy-crm.customer.my': 'My Customers',
  'menu.zy-crm.customer.pool': 'Customer Pool',
  'menu.zy-crm.customer.all': 'All Customers',
  'menu.zy-crm.contact': 'Contact',
  'menu.zy-crm.contact.detail': 'Contact Detail',
  'menu.zy-crm.opportunity': 'Opportunities',
  'menu.zy-crm.opportunity.my': 'My Opportunities',
  'menu.zy-crm.opportunity.all': 'All Opportunities',
  'menu.zy-crm.opportunity.pool': 'Opportunity Pool',
  'menu.zy-crm.opportunity.detail': 'Opportunity Detail',
  'menu.zy-crm.quote': 'Quotation',
  'menu.zy-crm.quote.detail': 'Quote Detail',
  'menu.zy-crm.product': 'Product',
  'menu.zy-crm.product.detail': 'Product Detail',
  'menu.zy-crm.contract': 'Contract',
  'menu.zy-crm.contract.detail': 'Contract Detail',
  'menu.zy-crm.receipt': 'Receipt',
  'menu.zy-crm.receipt.detail': 'Receipt Detail',
  'menu.zy-crm.receipt-schedule': 'Receipt Schedule',
  'menu.zy-crm.receipt-schedule.detail': 'Receipt Schedule Detail',
  'menu.zy-crm.invoice': 'Invoice',
  'menu.zy-crm.invoice.detail': 'Invoice Detail',
  'menu.zy-crm.invoiceProfile': 'Invoice Profile',
  'menu.zy-crm.followUps': 'Follow Ups',
  'menu.zy-crm.tasks': 'Task Center',
  'menu.zy-crm.attachments': 'Attachment Center',
  'menu.zy-crm.governance': 'Data Governance',
  'menu.zy-crm.automationRules': 'Automation Rules',
  'menu.zy-crm.analytics.leadSource': 'Lead Source Analysis',
  'menu.zy-crm.permissions': 'Data Permissions',
  'menu.zy-crm.customerLimitConfigs': 'Private Pool Limits',
  'menu.zy-crm.customerPoolConfigs': 'Customer Pool Configs',
  'menu.zy-crm.leadPoolConfigs': 'Lead Pool Configs',
  'menu.zy-crm.leadAssignRules': 'Lead Assignment Rules',
  'menu.zy-crm.sourceChannels': 'Source Channel Configs',
  'menu.zy-crm.opportunityPipelines': 'Opportunity Pipelines',
  'menu.zy-crm.opportunityStages': 'Opportunity Stages',
  'menu.zy-crm.areas': 'Area Configs',
  'menu.zy-crm.industries': 'Industry Configs',
  'menu.zy-crm.contractConfigs': 'Contract Configs',
  'menu.zy-crm.productCategories': 'Product Categories',
  'menu.zy-crm.contractCodeRules': 'Contract Code Rules',
  'menu.zy-crm.productCodeRules': 'Product Code Rules',
  'menu.zy-crm.leads': 'Lead',
  'menu.zy-crm.leads.overview': 'Overview',
  'menu.zy-crm.leads.my': 'Mine',
  'menu.zy-crm.leads.team': 'Subordinates',
  'menu.zy-crm.leads.pool': 'Lead Pool',
  'menu.zy-crm.leads.all': 'All',
  'menu.zy-crm.leads.imported': 'Imported Leads',
  'menu.zy-crm.leads.importConflicts': 'Import Conflicts',
  'menu.zy-crm.customers': 'Customer',
  'menu.zy-crm.customers.overview': 'Overview',
  'menu.zy-crm.customers.my': 'Mine',
  'menu.zy-crm.customers.team': 'Subordinates',
  'menu.zy-crm.customers.collab': 'Collaborating',
  'menu.zy-crm.customers.pool': 'Customer Pool',
  'menu.zy-crm.customers.all': 'All',
  'menu.zy-crm.contacts': 'Contact',
  'menu.zy-crm.contacts.overview': 'Overview',
  'menu.zy-crm.contacts.my': 'Mine',
  'menu.zy-crm.contacts.team': 'Subordinates',
  'menu.zy-crm.contacts.collab': 'Collaborating',
  'menu.zy-crm.contacts.all': 'All',
  'menu.zy-crm.opportunities': 'Opportunity',
  'menu.zy-crm.opportunities.overview': 'Overview',
  'menu.zy-crm.opportunities.my': 'Mine',
  'menu.zy-crm.opportunities.followed': 'Followed',
  'menu.zy-crm.opportunities.team': 'Subordinates',
  'menu.zy-crm.opportunities.collab': 'Collaborating',
  'menu.zy-crm.opportunities.pool': 'Opportunity Pool',
  'menu.zy-crm.opportunities.all': 'All',
  'menu.zy-crm.quotes': 'Quotation',
  'menu.zy-crm.quotes.my': 'Mine',
  'menu.zy-crm.quotes.team': 'Subordinates',
  'menu.zy-crm.quotes.collab': 'Collaborating',
  'menu.zy-crm.quotes.all': 'All',
  'menu.zy-crm.contracts': 'Contract',
  'menu.zy-crm.contracts.my': 'Mine',
  'menu.zy-crm.contracts.team': 'Subordinates',
  'menu.zy-crm.contracts.collab': 'Collaborating',
  'menu.zy-crm.contracts.all': 'All Contracts',
  'menu.zy-crm.receipts': 'Receipt',
  'menu.zy-crm.receipts.list': 'Receipt',
  'menu.zy-crm.receipts.schedules': 'Receipt Schedule',
  'menu.zy-crm.receipts.schedules.detail': 'Receipt Schedule Detail',
  'menu.zy-crm.invoices': 'Invoice',
  'menu.zy-crm.invoices.detail': 'Invoice Detail',
  'menu.zy-crm.products': 'Product',
  'menu.zy-crm.products.detail': 'Product Detail',
  'menu.zy-crm.marketing': 'Marketing Campaigns',
  'menu.zy-crm.marketing.campaigns': 'Campaign List',
  'menu.zy-crm.marketing.campaigns.detail': 'Campaign Detail',
};
